import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CardBaseComponent } from '../card-base/card-base.component';
import { CardModel } from '../models/card.model';

@Component({
  selector: 'mb-card-hero',
  templateUrl: './card-hero.component.html',
  styleUrls: ['./card-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardBaseComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardHeroComponent {
  @Input() alignContent!: string;
  @Input() data!: CardModel;
  @Input() fuelLabelPosition = 'default';
  @Input() sperateFooter = false;
}
